module.exports = __webpack_public_path__ + "static/img/10.0d30fb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/6/1/sp/10.png
// module id = cnKr
// module chunks = 0